module.exports = __webpack_public_path__ + "static/img/home_picture_02.4d947b0.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/pc/images/home_picture_02.png
// module id = iIFB
// module chunks = 0